import { render } from "./AiLevelHelpJa.vue?vue&type=template&id=ee34627a"
import script from "./AiLevelHelpJa.vue?vue&type=script&lang=js"
export * from "./AiLevelHelpJa.vue?vue&type=script&lang=js"

import "./AiLevelHelpJa.vue?vue&type=style&index=0&id=ee34627a&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__